import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRainbow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M2.5 14.25C2.5 10 6 6.5 10 6.5s7.5 3.5 7.5 7.75m-12.5 0c0-2.742 2.333-5 5-5s5 2.258 5 5m-7 0c0-1.097.933-2 2-2s2 .903 2 2"
	})]
});
const ForwardRef = forwardRef(SvgRainbow);
export { ForwardRef as ReactComponent };
